import locationSchema from '@data/schemas/location'
import { ObjectSchema, object, string } from 'yup'

const schema: ObjectSchema<TPlace, TPlace> = locationSchema.concat(
    object<TPlace>()
        .shape({
            placeId: string().required(),
        })
        .noUnknown()
)

export default schema
